export function formateCpf(cpf?: string | number) {
  if (!cpf) return "";

  const strCpf = String(cpf);
  const cleanCpf = strCpf.replace(/\D/g, '');

  if (cleanCpf.length > 11) return strCpf;

  return cleanCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
}

export function formatCNPJ(value: string | number | undefined): string {
  if (!value) return '';
  
  const digits = value.toString().replace(/\D/g, '').slice(0, 14);
  
  if (digits.length === 14) {
    return digits.replace(
      /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/,
      '$1.$2.$3/$4-$5'
    );
  }

  return digits;
}
export function formatPhone(value: string | number | undefined): string {
  if (!value) return '';
  const digits = value.toString().replace(/\D/g, '');

  if (digits.length === 10) {
    return digits.replace(/^(\d{2})(\d{4})(\d{4})$/, '($1) $2-$3');
  } else if (digits.length === 11) {
    return digits.replace(/^(\d{2})(\d{5})(\d{4})$/, '($1) $2-$3');
  } else {
    return digits;
  }
}

export function formatPhoneInput(phone: string): string {
  const digits = phone.replace(/\D/g, "").slice(0, 11); 
  
  if (digits.length <= 2) {
    return digits; 
  }
  if (digits.length <= 7) {
    return `${digits.slice(0, 2)}-${digits.slice(2)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}


export function formatCEP(value: string | number | undefined): string {
  if (!value) return '';

  const digits = value.toString().replace(/\D/g, '').slice(0, 8);

  if (digits.length <= 5) {
    return digits;
  } else {
    return `${digits.slice(0, 5)}-${digits.slice(5)}`;
  }
}

export function formatRole(role: string): string {
  return role
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
}